import React from 'react';
import Text from '../../../../Components/Base/Text/Text';
import styles from './ORSMFaqs.module.scss';
import ORSMFaqsItem from './ORSMFaqsItem';

const FAQS: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const ORSMFaqs: React.FC = () => {
	return (
		<div className={styles.wrapper}>
			<Text tx='component.ORSMFaqs.title' className={styles.title} />
			<Text tx='component.ORSMFaqs.subtitle' className={styles.subtitle} />
			<div className='row'>
				<div className='col-md-8 col-12 offset-md-2'>
					<div className={styles.list}>
						{FAQS.map(item => (
							<ORSMFaqsItem
								key={`faq_${item}`}
								title={`component.ORSMFaqs.item${item}.title`}
								text={`component.ORSMFaqs.item${item}.text`}
							/>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ORSMFaqs;
